import {
    CHECKIN_CHECKOUT_FETCH_COMPANY_DATA
} from './actionTypes';

export function fetchCompanyData(currentUser) {
    return {
        type: CHECKIN_CHECKOUT_FETCH_COMPANY_DATA,
        currentUser
    }
}